// removed by extract-text-webpack-plugin
module.exports = {"propertyDetails":"_3fCQXS1FwMca64rCojNZwB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenPropertyCell/FullScreenPropertyCellAdditionalInfo/FullScreenPropertyCellAdditionalInfo.scss
// module id = 1615
// module chunks = 0